var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"skeleton-main"},_vm._l((_vm.options.moduleCount),function(opt){return _c('div',{key:opt,staticClass:"item",style:(`backgroundColor: ${_vm.backgroundColor};borderRadius: ${!_vm.isEditor ? 0 : '5px'};marginBottom: ${!_vm.isEditor ? 0 : '12px'}`)},_vm._l((_vm.options.count),function(item){return _c('div',{key:item,staticClass:"item-line",class:[
        item === 1 ? 'w-20' : '',
        item === 2 ? 'w-50' : '',
        item === 5 ? 'w-30' : '',
        item === 2 ? 'margin-t-36' : 'margin-t-20',
        !_vm.isEditor ? 'animation' : ''
      ]})}),0)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }